














import HomePage from './template'

import { LookupSVGFile, GetSVGFile } from '@/api/svg'

import mixins from './mixin'

export default mixins.extend({
  name: 'HawaPanelSVG',
  props: {
    value: Object,
  },
  data() {
    return {
      templateVisible: false,
      template: { ...HomePage },
      error: false,
      errorMessage: '',
    }
  },
  methods: {
    async getPage() {
      try {
        const info = await LookupSVGFile(this.value.data.uid)
        this.error = false
        this.errorMessage = ''

        const data = await GetSVGFile(info.uid, info.slug)
          // eslint-disable-next-line
        ;(this.template as any) = undefined
        this.template = { ...HomePage }
        this.template.name = 'runtimeImage'
        this.template.template = `<div style="max-height:100%; max-width:100%; height:100%;">${data}<component is="style">${this.value.data.style}</component></div>`
        this.templateVisible = true
      } catch (e) {
        this.templateVisible = false
        this.error = true
        this.errorMessage = e.data.message
        return
      }
    },
  },
  watch: {
    '$route.params.template': function() {
      this.getPage()
    },
  },

  created() {
    if (this.value.snapshot) {
      //
    } else {
      this.getPage()
    }
  },
})
